export enum QueryParams {
  ISIN = "isin",
  ApiKey = "api_key",
}
